import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class SubNav extends Component {

    isActive(path) {
        return this.props.location.pathname.startsWith(path);
    }

    navigate(path) {
        window.location.href = path;
    }

    render() {
        const editorActive = this.isActive('/slides/editor');
        const converterActive = this.isActive('/slides/converter');
        const pcoSongsActive = this.isActive('/slides/pco_songs');
        const themesActive = this.isActive('/slides/themes');

        return (
            <div className="bg-white border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4">
                    <nav className="flex space-x-8">
                        <button
                            onClick={() => this.navigate('/slides/editor')}
                            className={"py-3 px-1 border-b-2 text-sm font-medium " +
                                (editorActive
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300")}
                        >
                            Slide Editor
                        </button>
                        <button
                            onClick={() => this.navigate('/slides/converter')}
                            className={"py-3 px-1 border-b-2 text-sm font-medium " +
                                (converterActive
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300")}
                        >
                            Document Converter
                        </button>
                        <button
                            onClick={() => this.navigate('/slides/pco_songs')}
                            className={"py-3 px-1 border-b-2 text-sm font-medium " +
                                (pcoSongsActive
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300")}
                        >
                            Songs
                        </button>
                        <button
                            onClick={() => this.navigate('/slides/themes')}
                            className={"py-3 px-1 border-b-2 text-sm font-medium " +
                                (themesActive
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300")}
                        >
                            Themes
                        </button>
                    </nav>
                </div>
            </div>
        );
    }
}

export default withRouter(SubNav);
